import { PropsWithChildren } from 'react';
import { Box, FelaCSS } from '@bridebook/ui';
import mergeStyles from '../../../../fela-utils/merge-styles';
import { IStylingProps } from '../../../../themes/types';
import componentStyles from './h5.style';

interface IProps extends IStylingProps, PropsWithChildren {
  style?: FelaCSS;
}

/**
 * @deprecated
 * Use Text or DisplayText from bridebook/aura instead.
 */
const H5 = ({ style = {}, children, ...restProps }: IProps) => {
  const styles = componentStyles();

  return (
    <Box as="h5" style={mergeStyles([styles.wrapper, style])} data-name="h5" {...restProps}>
      {children}
    </Box>
  );
};

export default H5;
